export const questionsTypes = [
  {
    symbol: "R",
    type: "الواقعي",
  },
  {
    symbol: "I",
    type: "المستكشف",
  },
  {
    symbol: "A",
    type: "الفنان",
  },
  {
    symbol: "S",
    type: "الاجتماعي",
  },
  {
    symbol: "E",
    type: "المبادر",
  },
  {
    symbol: "C",
    type: "المنظم",
  },
];
